class StickyAddToCard extends HTMLElement {
    constructor() {
        super();
        this.handleScroll = this.handleScroll.bind(this);
    }

    connectedCallback() {
        document.addEventListener("scroll", this.handleScroll, {
            passive: true,
        });
        window.addEventListener("resize", this.handleScroll);
        this.handleScroll();
    }

    handleScroll() {
        const footer = document.querySelector(".footer-section");
        const footerVisible = footer
            ? footer.getBoundingClientRect().top < window.innerHeight
            : false;
        const visible = window.scrollY > 550 && !footerVisible;

        this.classList.toggle("is-visible", visible);
        this.setAttribute("aria-hidden", visible ? "false" : "true");
    }

    disconnectedCallback() {
        document.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleScroll);
    }
}

customElements.define("sticky-add-to-card", StickyAddToCard);
